export default {"src":"/_next/static/media/rdd.d6220c0a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};